import { quickProperty, designToken } from '../component-tokens';
import { neutralButton, buttonBaseAttributes } from './button';
import { linearProgressIndicator } from './progressIndicator';
export const snackbarTokens = {
    name: 'snackbar',
    tag: 'chameleon-snackbar',
    reactImports: 'Snackbar',
    attributes: {
        'background-color': designToken('snackbar-background'),
        'box-sizing': quickProperty('border-box'),
        'min-height': quickProperty('48px'),
        'min-width': quickProperty('320px'),
        'max-width': quickProperty('408px'),
        display: quickProperty('inline-flex'),
        'border-radius': quickProperty('4px'),
        'box-shadow': designToken('elevation-300'),
        color: designToken('text-04'),
        padding: quickProperty('12px 16px'),
        '--goto-button-margin': quickProperty('0 2px'),
    },
    children: [
        {
            name: 'message',
            attributes: {
                display: quickProperty('flex'),
                'flex-direction': quickProperty('column'),
                width: quickProperty('100%'),
            },
        },
        {
            name: 'buttons',
            attributes: {
                display: quickProperty('flex'),
                gap: designToken('spacing-01'),
                'align-items': quickProperty('center'),
                'margin-left': designToken('spacing-03'),
            },
        },
        {
            name: 'title',
            attributes: {
                margin: quickProperty('0'),
                font: designToken('body-small'),
                color: designToken('text-04'),
            },
        },
        {
            name: 'content',
            attributes: {
                margin: quickProperty('0'),
                font: designToken('caption-default-01'),
                color: designToken('snackbar-content-color'),
            },
        },
        linearProgressIndicator,
        {
            name: 'actions',
            attributes: {
                display: quickProperty('flex'),
                'justify-content': quickProperty('flex-end'),
            },
            children: [
                Object.assign(Object.assign({}, neutralButton), { name: 'button', attributes: Object.assign(Object.assign({}, buttonBaseAttributes), neutralButton.attributes) }),
            ],
        },
        {
            name: 'stacked',
            attributes: {
                'flex-direction': quickProperty('column'),
            },
            children: [
                {
                    name: 'actions',
                    attributes: {
                        'padding-top': designToken('spacing-04'),
                    },
                },
            ],
        },
    ],
};
